<template>
  <!-- <a-card :bordered="false"> -->
  <component @onAdd="handleEdit" @onCouponList="handleCouponList" @onGoBack="handleGoBack" :is="currentComponet"></component>
  <!-- </a-card> -->
</template>

<script>
  // 动态切换组件
  import List from '@/views/SellerCoupons/NumberCoupon_component/ListNew'
  import Add from '@/views/SellerCoupons/NumberCoupon_component/Add'
  import CouponList from '@/views/SellerCoupons/NumberCoupon_component/List'

  export default {
    components: {
      List,
      Add,
      CouponList
    },
    data() {
      return {
        currentComponet: 'List'
      }
    },
    created() {},
    methods: {
      handleEdit() {
        this.currentComponet = 'Add'
      },
      handleGoBack() {
        this.currentComponet = 'List'
      },
      handleCouponList() {
        this.currentComponet = 'CouponList'
      }
    },
    watch: {
      '$route.path'() {
        this.currentComponet = 'List'
      }
    }
  }
</script>
